var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeEcoLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 7.61a5.498 5.498 0 00-7.568-5.137A5.5 5.5 0 0061 7.53V9h-2v12h15V9h-2V7.61zM68 18h-3v-6h3v6zm1-9h-5V7.53a2.48 2.48 0 011-2 2.49 2.49 0 014 2.1V9zM56.66 51.1a20.18 20.18 0 01-9.89 7.06c-10.92 3.53-22.72-2.73-26.36-14-3.64-11.27 2.26-23.24 13.18-26.77a20.08 20.08 0 012.16-.55A20.93 20.93 0 0056.66 51.1z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_eco_locked.f5fd5957.svg";
export { SvgF1ModeEcoLocked as ReactComponent };